import { Container, Grid, Typography, Link, Divider, Box } from "@mui/material";
import { useTranslation } from "react-i18next"; 

const Footer = () => {
  const { t } = useTranslation(); 

  const LinkSection = ({ title, links }) => (
    <Box>
      <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
        {title}
      </Typography>
      <Grid container direction="column" spacing={1.5}>
        {links.map((link) => (
          <Grid item key={link.text}>
            <Link
              href={link.href}
              color="inherit"
              underline="none"
              sx={{
                "&:hover": {
                  color: "primary.main",
                },
              }}
            >
              {link.text}
            </Link>
          </Grid>
        ))}
      </Grid>
    </Box>
  );

  // Define navigation links with translations
  const navigationLinks = [
    { text: t("footer.navigateLinks.home"), href: "/" },
    { text: t("footer.navigateLinks.brand"), href: "/" },
    { text: t("footer.navigateLinks.creator"), href: "/" },
    { text: t("footer.navigateLinks.pricing"), href: "/" },
    { text: t("footer.navigateLinks.aboutUs"), href: "/" },
  ];

  // Define support links with translations
  const supportLinks = [
    { text: t("footer.supportLinks.faqs"), href: "/" },
    { text: t("footer.supportLinks.supportCenter"), href: "/" },
  ];

  // Define contact links with translations
  const contactLinks = [
    { text: t("footer.contactLinks.email"), href: "mailto:collabbarter@.com" },
    { text: t("footer.contactLinks.phone"), href: "tel:+011234567890" },
  ];

  return (
    <Box component="footer" sx={{ bgcolor: "background.paper", pt: 6, pb: 4 }}>
      <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4, lg: 6 } }}>
        <Grid container spacing={{ xs: 4, md: 8 }}>
          <Grid item xs={12} md={5}>
            <Typography
              variant="h1"
              fontWeight={800}
              sx={{
                mb: 2,
                "& span": {
                  color: "#FFCF00",
                },
              }}
            >
              <span>COLLAB</span> BARTER
            </Typography>
            <Typography
              variant="body1"
              sx={{
                maxWidth: 450,
                lineHeight: 1.7,
              }}
            >
              {t("footer.intro")}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={2.5}>
            <LinkSection
              title={t("footer.sections.navigate")}
              links={navigationLinks}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={2.5}>
            <LinkSection
              title={t("footer.sections.supportUs")}
              links={supportLinks}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <LinkSection
              title={t("footer.sections.contactUs")}
              links={contactLinks}
            />
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: "black" }} />

        <Grid
          container
          spacing={{ sm: 2, xs: 1 }}
          justifyContent="space-between"
          alignItems="center"
          sx={{
            flexDirection: { xs: "column-reverse", sm: "row" },
            textAlign: { xs: "center", sm: "left" },
          }}
        >
          <Grid item xs={12} sm="auto">
            <Typography variant="body1">{t("footer.copyright")}</Typography>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Box
              sx={{
                display: "flex",
                gap: 3,
                justifyContent: { xs: "center", sm: "flex-start" },
                mb: { xs: 1, sm: 0 },
              }}
            >
              <Link
                href="/"
                color="inherit"
                underline="none"
                sx={{ "&:hover": { color: "primary.main" } }}
              >
                {t("footer.termsConditions")}
              </Link>
              <Link
                href="/"
                color="inherit"
                underline="none"
                sx={{ "&:hover": { color: "primary.main" } }}
              >
                {t("footer.privacyPolicy")}
              </Link>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;
